import API from "../../../utils/API";

export const GET_STAFF_NOTIFICATIONS_COUNT = "GET_STAFF_NOTIFICATIONS_COUNT";
export const GET_STAFF_NOTIFICATIONS = "GET_STAFF_NOTIFICATIONS";
export const LOAD_MORE_STAFF_NOTIFICATIONS = "LOAD_MORE_STAFF_NOTIFICATIONS";
export const STAFF_NOTIFICATION_ERROR = "STAFF_NOTIFICATION_ERROR";
export const SET_STAFF_NOTIFICATIONS_PAGES = "SET_STAFF_NOTIFICATIONS_PAGES"
export const getStaffNotificationsCount = () => async (dispatch) => {
    try {
        const { data } = await API.get("/api/staff-notifications/count");
        dispatch({ type: GET_STAFF_NOTIFICATIONS_COUNT, payload: data });
    } catch (error) {
        dispatch({ type: STAFF_NOTIFICATION_ERROR, payload: error.message });
    }
};

export const getStaffNotifications = () => async (dispatch) => {
    try {
        const { data } = await API.get("/api/staff-notifications?page=1&limit=10");
        dispatch({ type: GET_STAFF_NOTIFICATIONS, payload: data.notifications });
        dispatch({ type: SET_STAFF_NOTIFICATIONS_PAGES, payload: data.totalPages });
    } catch (error) {
        dispatch({ type: STAFF_NOTIFICATION_ERROR, payload: error.message });
    }
};


export const loadMoreStaffNotifications = (page) => async (dispatch) => {
    try {
        const { data } = await API.get(`/api/staff-notifications?page=${page}&limit=10`);
        dispatch({ type: LOAD_MORE_STAFF_NOTIFICATIONS, payload: data.notifications });
        return data.notifications;
    } catch (error) {
        dispatch({ type: STAFF_NOTIFICATION_ERROR, payload: error.message });
        return [];
    }
};

export const markStaffNotificationRead = (id) => async (dispatch) => {
    try {
        await API.patch("/api/staff-notifications/mark-as-read", { _id: id });
        dispatch(getStaffNotificationsCount());
    } catch (error) {
        console.error(error);
    }
};

export const markAllStaffNotificationsRead = () => async (dispatch) => {
    try {
        await API.patch("/api/staff-notifications/mark-all-as-read");
        dispatch(getStaffNotificationsCount());
    } catch (error) {
        console.error(error);
    }
};

export const clearStaffNotifications = () => async (dispatch) => {
    try {
        await API.delete("/api/staff-notifications/clear-all");
        dispatch(getStaffNotifications());
        dispatch(getStaffNotificationsCount());
    } catch (error) {
        console.error(error);
    }
};